import FormWidget from "../../../widgets/FormWidget/widget";
import {WidgetType} from "../../../constants/WidgetConstants";

class AtFormWidget extends FormWidget{
  static getWidgetType(): WidgetType {
    return "AT_FORM_WIDGET";
  }
}
export default AtFormWidget;
